<template>
	<div class="questionnaire">
		<div class="col" align-x="center">
			<el-button class="question-button" type="info" disabled v-if="questionnaireButtonDisable">填寫問卷</el-button>
			<div v-if="!is18 && !questionnaireButtonDisable">
				<a class="color-white question-button button-tp bg-pink1" :href="getQuestionnaireUrl('B')" target="_blank">填寫輔導員問卷</a>
			</div>
			<div v-if="is18 && !questionnaireButtonDisable">
				<a class="color-white question-button button-tp bg-pink1" :href="getQuestionnaireUrl('A')" target="_blank">填寫挑戰者問卷</a>
			</div>
			<p class="color-danger">*請每位{{is18 ? "挑戰者" : "輔導員"}}分別以各自帳號登入再填寫問卷（若以同一個帳號登入，將無法讀取每位{{is18 ? "挑戰者" : "輔導員"}}的資料喔～）</p>
		</div>
		<div class="reload layout-row layout-hv-center">
			<div class="reload-button button-tp color-white bg-green1" @click="reloadQuestionnaire">重新讀取資料</div>
			<div class="tips color-text2">*填寫完問卷請點選左側「重新讀取資料」按鈕，自己的名字顏色轉變成綠色即填寫成功</div>
		</div>
		<QuestionnaireStatus></QuestionnaireStatus>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import QuestionnaireStatus from "@/components/challenge/signUp/editStory/QuestionnaireStatus.vue";

export default {
	props: ["is18"],
	data() {
		return {
			questionnaireA: process.env.VUE_APP_QUESTIONNAIRE_A,
			questionnaireB: process.env.VUE_APP_QUESTIONNAIRE_B
		};
	},
	computed: {
		...mapState("user", ["userInfo"]),
		...mapState("story", ["editStoryData"]),
		questionnaireButtonDisable() {
			return (this.userInfo && this.userInfo.role == "visitor") || false;
		}
	},
	methods: {
		...mapActions("story", ["getQuestionnaireStatus", "checkProgress", "updateStory"]),
		getQuestionnaireUrl(type) {
			const userId = `${this.editStoryData.form_type}_${this.userInfo.id}`;
			const url = type === 'A' ? this.questionnaireA : this.questionnaireB;
			// JotForm 使用 USER_ID，SurveyCake 使用 aka_user_id
			const isJotForm = url.includes('jotform.com');
			const paramName = isJotForm ? 'USER_ID' : 'aka_user_id';
			return `${url}?${paramName}=${userId}`;
		},
		colorClass(status) {
			return {
				"color-green1": status,
				"color-danger": !status
			};
		},
		bgClass(status) {
			return {
				"bg-green1": status,
				"bg-danger": !status
			};
		},
		async reloadQuestionnaire() {
			await this.getQuestionnaireStatus();
			await this.checkProgress();
			await this.updateStory(this.editStoryData);
		}
	},
	created() { },
	mounted() { },
	components: {
		QuestionnaireStatus
	}
};
</script>

<style lang="scss" scoped>
.questionnaire {
	padding: 20px 0;

	.question-button {
		width: 379px;
		height: 52px;
		text-decoration: none;
	}

	.reload {
		margin-top: 40px;
		margin-bottom: 15px;

		.reload-button {
			width: 149px;
			height: 30px;
		}

		.tips {
			margin-left: 11px;
			font-size: 12px;
		}
	}
}
</style>